import { gql } from 'glimmer-apollo';

export const STREAMER_QUERY = gql`
  query ($slug: String) {
    streamer: streamerCollection(where: { slug: $slug }, limit: 1) {
      items {
        displayName
        slug
        avatar {
          url
        }
        bannerImage {
          url
        }
        bio
        country
        isLive
        followers
        totalViews
        twitchHandle
        youtubeHandle
        twitterHandle
        instagramHandle
        favouriteGames: gamesCollection(limit: 5) {
          items {
            title
            slug
            coverImage {
              url
            }
          }
        }
        recentStreams: streamsCollection(limit: 10, order: [date_DESC]) {
          items {
            title
            date
            duration
            viewers
            game {
              title
              slug
              coverImage {
                url
              }
            }
            thumbnail {
              url
            }
          }
        }
        scheduleItems: scheduleCollection(limit: 7, order: [date_ASC]) {
          items {
            date
            game {
              title
              slug
            }
            description
          }
        }
      }
    }
  }
`;
